<template>
  <div id="app">
        <router-view/>
  </div>
</template>
<script>
export default {
     mounted() {
        //  let that = this
        // var new_element = document.createElement("script");
        // new_element.setAttribute("type", "text/javascript");
        // new_element.setAttribute(
        //     "src",
        //     "https://g.alicdn.com/code/lib/vConsole/3.4.0/vconsole.min.js"
        // );
        // document.body.appendChild(new_element);
        // window.onload = function () {
        //     let vConsole = new window.VConsole();
        //     console.log(vConsole);
        //     console.log('11',window.getToken)
        //     window.getToken(that.callback)
        // };
    },
    methods:{
        // callback(res) {
        //     // setInterval(() => {
        //         console.log('22',res)
        //     // }, 3000);
        //     if (res.token) {
        //         // setInterval(() => {
        //             console.log("token，", res.token);
        //         // }, 5000);
        //     } else {
        //         console.log("token为空");

        //     }
        // },
    }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  overflow: hidden;
}
html,
body,
div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
b,
u,
i,
center,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
caption,
tbody,
tfoot,
thead,
article,
aside,
canvas,
details,
embed,
figure,
figcaption,
footer,
header,
hgroup,
menu,
nav,
output,
ruby,
section,
summary,
time,
mark,
audio,
video {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  font-weight: normal;
  vertical-align: baseline;
}
ol,
ul,
li {
  list-style: none;
}

/* custom */
a {
  /* color: #7e8c8d; */
  text-decoration: none;
  backface-visibility: hidden;
}
::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}
::-webkit-scrollbar-track-piece {
  background-color: rgba(0, 0, 0, 0.2);
  -webkit-border-radius: 6px;
}
::-webkit-scrollbar-thumb:vertical {
  height: 5px;
  background-color: rgba(125, 125, 125, 0.7);
  -webkit-border-radius: 6px;
}
::-webkit-scrollbar-thumb:horizontal {
  width: 5px;
  background-color: rgba(125, 125, 125, 0.7);
  -webkit-border-radius: 6px;
}
html,
body {
  width: 100%;
  height: 100%;
  font-family: "Arial", "Microsoft YaHei", "黑体", "宋体", "微软雅黑",
    sans-serif;
  overflow: hidden;
}
body {
  line-height: 1;
  -webkit-text-size-adjust: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
html {
  overflow-y: scroll;
}
img[src=""],img:not([src]){
    opacity:0;
  }
/* flex布局 */
.flex {
  display: flex;
}
.flex-direction-row {
  flex-direction: row;
}
.flex-direction-column {
  flex-direction: column;
}
.flex-wrap {
  flex-wrap: wrap;
}
.flex-wrap-no {
  flex-wrap: nowrap;
}
.justify-content-start {
  justify-content: flex-start;
}
.justify-content-end {
  justify-content: flex-end;
}
.justify-content-center {
  justify-content: center;
}
.justify-content-between {
  justify-content: space-between;
}
.justify-content-around {
  justify-content: space-around;
}
.align-items-start {
  align-items: flex-start;
}
.align-items-end {
  align-items: flex-end;
}
.align-items-center {
  align-items: center;
}
@font-face {
    font-family: puhui;
    src: url('https://res.xiaoxxx.com/test/m.xiaoxxx.com/20210708440f6b818d8a97be187472.otf');
}
@keyframes fadeIn{
    0%{opacity: 0;}
    100%{opacity: 1;}
}
/* @font-face {
    font-family: puhuih;
    src: url('http://res.xiaoxxx.com/test/m.xiaoxxx.com/202109081a08fc841e15bac7475545.otf');
} */
</style>
